import React, { useState, useEffect} from 'react'
import { Row, Col, Image, Form, Button, Alert, Spinner } from 'react-bootstrap'
import { Link, useNavigate } from 'react-router-dom'
import axios from 'axios';
//import bcrypt from 'bcryptjs';
import Card from '../components/Card'
import { useAuth } from '../components/auth/AuthProvider';
import LanguageSwitcher from '../components/LanguageSwitcher';
import { useLanguage } from '../i18n/LanguageContext';
import Logo from '../components/partials/components/logo';
import AuthDecor from '../components/AuthDecor';
import auth5 from '../assets/images/auth/05.png'
import apiUrl from '../config/api';

const SignUp = () => {
   let navigate = useNavigate();
   const AuthProvider = useAuth();
   const { loginMe } = AuthProvider;
   const { t } = useLanguage();
   const [registrationEnabled, setRegistrationEnabled] = useState(true);
   const [registrationStatusLoading, setRegistrationStatusLoading] = useState(true);

   useEffect(() => {
      axios.get(`${apiUrl}/site-settings/public`, {
         skipAuthRefresh: true,
         skipAuthToken: true,
      })
      .then((response) => setRegistrationEnabled(response.data?.registrationEnabled !== false))
      .catch(() => setRegistrationEnabled(true))
      .finally(() => setRegistrationStatusLoading(false));
   }, []);

   useEffect(()=>{
      if (AuthProvider.isAuthenticated){
         navigate("/dashboard");
      }
   }, [AuthProvider.isAuthenticated, navigate]);

   //console.log("Authenticated:", isAuthenticated.isAuthenticated);
   /*
   useEffect(()=>{
      if (isAuthenticated){
         navigate("/dashboard");
      }
   }, [isAuthenticated, navigate]);*/

   const [formData, setFormData] = useState({
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      password: '',
      confirmPassword: '',
      agreeTerms: false,
    });

   const handleChange = (e) => {
      const { name, value, type, checked } = e.target;
      setFormData({
        ...formData,
        [name]: type === 'checkbox' ? checked : value,
      });
    };

   const handleSubmit = async (e) => {
      e.preventDefault();
      if (!registrationEnabled || registrationStatusLoading) {
         return;
      }
/*
      if (formData.password !== formData.confirmPassword) {
        alert("Passwords don't match");
        return;
      }
      
      if (!formData.agreeTerms) {
        alert('You must agree with the terms of use2');
        return;
      }*/
      // Simulate form submission, redirect to dashboard
      //navigate('/dashboard');
      // Invia i dati al backend
      /*const hashedPassword = bcrypt.hashSync(formData.password, 10)
      const hashedConfirmPassword = bcrypt.hashSync(formData.confirmPassword, 10)

      setFormData({
         ...formData,
         ["password"]: hashedPassword,
         ["confirmPassword"]: hashedConfirmPassword
       });*/
      
      await axios.post(`${apiUrl}/register`, formData, {
         withCredentials: true,
         skipAuthRefresh: true,
         skipAuthToken: true,
      })
      .then(function (response) {
         if(response.status === 201){
            loginMe(response.data.user, response.data.accessToken || response.data.token);
         }
      })
      .catch(function (error) {
         console.log(error);
         const isDisabled = error.response?.data?.code === 'REGISTRATION_DISABLED';
         const message = isDisabled
            ? t.auth.registrationDisabledMessage
            : error.response?.data?.msg || error.response?.data?.message || error.message;
         if (isDisabled) {
            setRegistrationEnabled(false);
         }
         alert(`${t.auth.registrationFailed} ${message}`);
     });
     };

    if (AuthProvider.isAuthLoading) {
      return null;
    }

    return (
      <>
         <section className="login-content">
            <Row className="m-0 align-items-center bg-white vh-100">
               <div className="col-md-6 d-md-block d-none bg-primary p-0 mt-n1 vh-100 overflow-hidden">
                  <Image src={auth5} className="Image-fluid gradient-main animated-scaleX" alt="images" />
               </div>
               <Col md="6">
                  <div className="auth-language-switcher">
                     <LanguageSwitcher placement="auth" />
                  </div>
                  <Row className="justify-content-center">
                     <Col md="10">
                        <Card className="card-transparent auth-card shadow-none d-flex justify-content-center mb-0">
                           <Card.Body>
                              <Link to="/" className="auth-brand-link navbar-brand d-flex align-items-center mb-3">
                                 <Logo />
                                 <h4 className="logo-title ms-3">Quizify</h4>
                              </Link>
                              <h2 className="mb-2 text-center">{t.auth.signUpTitle}</h2>
                              <p className="text-center">{t.auth.signUpSubtitle}</p>
                              {!registrationStatusLoading && !registrationEnabled && (
                                 <Alert variant="warning" className="text-center">
                                    <strong className="d-block">{t.auth.registrationDisabledTitle}</strong>
                                    {t.auth.registrationDisabledMessage}
                                 </Alert>
                              )}
                              <Form onSubmit={handleSubmit}>
                                 <fieldset disabled={registrationStatusLoading || !registrationEnabled}>
                                 <Row>
                                    <Col lg="6">
                                       <Form.Group className="form-group">
                                          <Form.Label htmlFor="firstName" className="">{t.auth.firstName}</Form.Label>
                                          <Form.Control type="text" className="" name="firstName"id="firstName" onChange={handleChange} placeholder=" " required/>
                                       </Form.Group>
                                    </Col>
                                    <Col lg="6">
                                       <Form.Group className="form-group">
                                          <Form.Label htmlFor="lastName" className="">{t.auth.lastName}</Form.Label>
                                          <Form.Control type="text" className="" name="lastName" id="lastName" onChange={handleChange} placeholder=" " required />
                                       </Form.Group>
                                    </Col>
                                    <Col lg="6">
                                       <Form.Group className="form-group">
                                          <Form.Label htmlFor="email" className="">{t.auth.email}</Form.Label>
                                          <Form.Control type="email" className="" name="email" id="email" onChange={handleChange} placeholder=" " required />
                                       </Form.Group>
                                    </Col>
                                    <Col lg="6">
                                       <Form.Group className="form-group">
                                          <Form.Label htmlFor="phone" className="">{t.auth.phone}</Form.Label>
                                          <Form.Control type="text" className="" name="phone" id="phone" onChange={handleChange} placeholder=" " />
                                       </Form.Group>
                                    </Col>
                                    <Col lg="6">
                                       <Form.Group className="form-group">
                                          <Form.Label htmlFor="password" className="">{t.auth.password}</Form.Label>
                                          <Form.Control type="password" className="" name="password" id="password" onChange={handleChange} placeholder=" " required />
                                       </Form.Group>
                                    </Col>
                                    <Col lg="6">
                                       <Form.Group className="form-group">
                                          <Form.Label htmlFor="confirmPassword" className="">{t.auth.confirmPassword}</Form.Label>
                                          <Form.Control type="password" className="" name="confirmPassword" id="confirmPassword" onChange={handleChange}  placeholder=" " required />
                                       </Form.Group>
                                    </Col>
                                    <Col lg="12" className="d-flex justify-content-center">
                                       <Form.Check className="mb-3 form-check">
                                          <Form.Check.Input type="checkbox" name="agreeTerms" id="agreeTerms" onChange={handleChange} required /> 
                                          <Form.Check.Label htmlFor="agreeTerms">{t.auth.agreeTerms}</Form.Check.Label>
                                       </Form.Check>
                                    </Col>
                                 </Row>
                                 <div className="d-flex justify-content-center">
                                    <Button type="submit" variant="primary">
                                       {registrationStatusLoading ? <Spinner animation="border" size="sm" /> : t.auth.signUpButton}
                                    </Button>
                                 </div>
                                 </fieldset>
                                 {/*
                                 <p className="text-center my-3">or sign in with other accounts?</p>
                                 <div className="d-flex justify-content-center">
                                    <ListGroup as="ul" className="list-group-horizontal list-group-flush">
                                       <ListGroup.Item as="li" className="list-group-item border-0 pb-0">
                                          <Link to="#"><Image src={facebook} alt="fb" /></Link>
                                       </ListGroup.Item>
                                       <ListGroup.Item as="li" className="list-group-item border-0 pb-0">
                                          <Link to="#"><Image src={google} alt="gm" /></Link>
                                       </ListGroup.Item>
                                       <ListGroup.Item as="li" className="list-group-item border-0 pb-0">
                                          <Link to="#"><Image src={instagram} alt="im" /></Link>
                                       </ListGroup.Item>
                                       <ListGroup.Item as="li" className="list-group-item border-0 pb-0">
                                          <Link to="#"><Image src={linkedin} alt="li" /></Link>
                                       </ListGroup.Item>
                                    </ListGroup>
                                 </div>
                                 */}
                                 <p className="mt-3 text-center">
                                    {t.auth.alreadyHaveAccount} <Link to="/sign-in" className="text-underline">{t.auth.signInButton}</Link>
                                 </p>
                              </Form>
                           </Card.Body>
                        </Card>
                     </Col>
                  </Row>
                  <div className="sign-bg sign-bg-right">
                     <AuthDecor />
                  </div>
               </Col>
            </Row>
         </section>
      </>
   )
}

export default SignUp
